//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import * as api from "@/api";
import SoundsService from './SoundService';

import {
  RewardModal
} from "@/components/UI";

import { GameMode, MAX_MULTIPLIERS, GameStatus, BetType } from './enum';

import LastWins from './last-wins.vue';
import DifficultyGame from './difficulty-game.vue';
import BetCreatorRatios from './bet-creator-ratios.vue';
import BetCreator from './bet-creator.vue';
import BetTake from './bet-take.vue';
import BetComponent from './bet-component.vue';
import GameField from './game-field.vue';
import HomeActions from './home-actions.vue';
import CurrentGame from './сurrent-game.vue';
import OnlineCountBadge from './online-count-badge.vue';
import InteractivePanel from "@/components/interactive_panel";

const GAME_COEFFICIENTS = Array.from({ length: 3 }, (_, i) => Array.from({ length: 20 }, (_, i) => 1.2 ** (i + 1)));

export default {
  name: 'ChickenRoadHome',
  components: {
    LastWins,
    DifficultyGame,
    BetCreatorRatios,
    BetCreator,
    BetTake,
    BetComponent,
    'chicken-road-game-field': GameField,
    HomeActions,
    CurrentGame,
    OnlineCountBadge,
    InteractivePanel,
    'c-RewardModal': RewardModal
  },
  data() {
    return {
      gameState: {
        currentGame: null,
        selectedMode: GameMode.EASY,
        isMakingStep: false,
        isAnimating: false,
        isCreatingGame: false,
        isEndingGame: false,
        betAmount: 0.25,
        betType: BetType.BALANCE,
        onlineCount: 0,
        allGames: [],
        topGames: [],
        coefficients: GAME_COEFFICIENTS,
      },
      soundsService: new SoundsService(),
      BetType: BetType,
      notice_modal_show: false,
      modeDescriptionData: [],
      howItWorksSlides: [],
      mediaQueryList: null,
      settingsState: {
        isSettingsTooltipOpen: false,
        disableAnimations: false,
        disableChickenRoadSounds: false,
        disableChickenRoadMusic: false
      }
    };
  },
  computed: {
    ...mapState(["user"]),
    isAuthenticated() {
      return this.user.id > 0 || this.user.id != null || this.user.id != undefined || false;
    },
    betType() {
      return this.gameState.betType || BetType.BALANCE;
    },
    onlineCount() {
      return this.gameState.onlineCount || 0;
    },
    needPlayBalance() {
      return this.$store?.state?.roleplaying?.needPlayBalance || 0;
    },
    isShowRoleplayingButton() {
      return this.needPlayBalance > 0;
    },
    allBalance() {
      if (this.currencyType === 1) return this.user?.happyCoin || 0;
      if (this.currencyType === 2) return this.user?.coin1Available || 0;
      return this.user?.recycles || 0;
    },
    isHappyCoin() {
      return this.currencyType === 1;
    },
    isAutoConverted() {
      return this.currencyType === 1 || this.currencyType === 2;
    },
    currencyType() {
      return Number(this.$route.meta.currencyType ?? this.$route.query.currencyType ?? (this.$route.query.uhc == 1 ? 1 : 0));
    },
  },
  async mounted() {
    window.addEventListener('keydown', this.handleSpaceKey);

    await this.loadConfigs();

    if (this.isAuthenticated) {
      await this.loadCurrentGame();
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(async () => await this.loadAllGames(), { timeout: 5000 });
      window.requestIdleCallback(async () => await this.loadTopGames(), { timeout: 8000 });
    } else {
      setTimeout(async () => await this.loadAllGames(), 3000);
      setTimeout(async () => await this.loadTopGames(), 5000);
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleSpaceKey);
  },
  methods: {
    // 1. 未登录回调：打开登录框
    handleOpenLoginModal() {
       this.$store.commit('setloginModal', true);
    },

    // 2. 自定义余额检查（可选）
    checkBalance() {
      if (this.allBalance < this.gameState.betAmount) {
        this.$toast.error('余额不足，请先充值');
        return false;
      }
      return true;
    },

    // 3. 创建游戏回调（开始新一局）
    async handleCreateGame() {
      // payload 结构: 
      // 余额模式: { betType: 'BALANCE', amount: 1.5 }
      // 皮肤模式: { betType: 'INVENTORY', selectedIds: ['item_1001'] }
      const payload = {
        mode: this.gameState.selectedMode,
        betType: this.betType,
        amount: this.gameState.betAmount,
        isHappyCoin: this.isHappyCoin
        ,currencyType: this.currencyType
      };
      this.gameState.isCreatingGame = true;
      try {
        const res = await api.chickenRoadCreateGame(payload);

        if(res.data.code == 0){
          this.gameState.currentGame = res.data.data; // 更新游戏状态为 IN_PROGRESS
        } else {
          this.$toast.error(res.data.msg);
        } 
        
      } catch (err) {
        console.error(err);
      } finally {
        this.gameState.isCreatingGame = false;
        setTimeout(() => {
          // 更新用户信息
          this.$store.commit('setInfo');
        }, 500)
      }
    },

    // 4. 游戏中进行下一步
    async handleMakeStep() {
      this.gameState.isMakingStep = true;
      try {
        const res = await api.chickenRoadNextStep({ gameId: this.gameState.currentGame.id, currencyType: this.currencyType });
        this.gameState.currentGame = res.data.data;
      } finally {
        this.gameState.isMakingStep = false;

        if (this.gameState.currentGame.status != 1) {
          setTimeout(async () => await this.loadAllGames(), 3000);
          setTimeout(async () => await this.loadTopGames(), 5000);
        }
      }
    },

    // 提取奖励
    async handleEndGame() {
      this.gameState.isEndingGame = true;
      try {
        const res = await api.chickenRoadEndGame({ gameId: this.gameState.currentGame.id, currencyType: this.currencyType });
        this.gameState.currentGame = res.data.data;
        const item = res.data.data.winItem;
        this.$refs.reward_ui.pushItem(
          item.name,
          item.mSerial,
          item.itemPic,
          item.rarity,
          item.price,
          ''
        );
        await this.$refs.reward_ui.show();
        this.$refs.reward_ui.isShow = true;
      } finally {
        this.gameState.isEndingGame = true;
        setTimeout(() => {
          // 更新用户信息
          this.$store.commit('setInfo');
        }, 500)
        setTimeout(async () => await this.loadAllGames(), 3000);
        setTimeout(async () => await this.loadTopGames(), 5000);
      }
    },

    // 5. 上局已输/赢，再玩一次时触发重置
    async handleResetGame() {
      this.gameState.currentGame = null;
      this.gameState.isEndingGame = false;
      this.gameState.isMakingStep = false;
      this.gameState.isAnimating = false;
      this.gameState.isCreatingGame = false;

    },
    // 6. 错误通知回调（如金额未达到最低 0.25 限制）
    handleShowError(msg) {
      this.$toast.error(msg);
    },
    handleModeChange(newMode) {
      console.log('玩家切换了难度:', newMode);
      // 可在此处重新调用获取步骤 API，如：
      // this.fetchSteps(newMode);
    },
    handleToggleSettings() {
      this.settingsState.isSettingsTooltipOpen = !this.settingsState.isSettingsTooltipOpen;
    },
    handleOpenRulesModal() {
      this.notice_modal_show = true;
    },
    handleSpaceKey(event) {
      if (event.code !== 'Space' && event.keyCode !== 32) return;

      const target = event.target;
      const isInputElement =
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable;

      if (isInputElement || this.settingsState.isSettingsTooltipOpen) {
        return;
      }

      event.preventDefault();

      if (this.$refs.betCreator && typeof this.$refs.betCreator.placeBet === 'function') {
        this.$refs.betCreator.placeBet();
      }
    },
    async loadCurrentGame() {
      const resonpone = await api.chickenRoadGetCurrentGame({ currencyType: this.currencyType });

      this.gameState.currentGame = resonpone.data.data || null;
      this.gameState.selectedMode = resonpone.data.data?.mode || GameMode.EASY;

    },
    async loadAllGames() {
      const response = await api.chickenRoadHistoryAll({limitWin: true, currencyType: this.currencyType});
      const rawGames = response?.data?.data?.games || [];

      this.gameState.allGames = rawGames.slice(0, 8);

      this.gameState.onlineCount = response?.data?.data?.online || 0;
    },
    async loadTopGames() {
      const resonpone = await api.chickenRoadHistoryTop({ currencyType: this.currencyType });
      this.gameState.topGames = resonpone.data.data.games.slice(0, 8) || null;
      this.gameState.onlineCount = resonpone.data.data.online || 0;
    },
    async loadConfigs() {
      const resonpone = await api.chickenRoadConfig({ currencyType: this.currencyType });
      this.gameState.coefficients = resonpone.data.data || null;
    }
  }
};
